
import Vue from 'vue'
import MainNavigationDrawer from "@/components/Drawers/MainNavigationDrawer.vue";
import ItemsSliderWithTitle from "@/components/Items/ItemsSliderWithTitle.vue"
import { mapState } from 'vuex';
import StoreService from '@/services/storeService';
import StoreSettings from '@/models/StoreSettings';
import { EStoreType } from '@/enums/EStoreType';
import routerManager from '@/routerManagerNew/routerManager';
import ElementGenerator from '@/components/UI/Elements/ElementGenerator.vue';
import OrderTypeSelector from '@/components/Orders/OrderTypeSelector.vue'
import { ECategorizationLayerGroup } from '@/models/StoreCategorizationsAndLayersStructure';
import { canUseSelectedStore, ensureSelectedStoreForRoute } from '@/helpers/ssrStorefrontHelper';
import {
    buildCanonicalUrl,
    buildSeoMeta,
    buildSeoTitle,
    buildStoreJsonLd,
    getRuntimeSeoConfig
} from "@/helpers/seoMetaHelper";

export default Vue.extend({
    props: {
        storeId: { 
            required: true   
        }
    },

    components: {
        "main-navigation-drawer": MainNavigationDrawer,
        "item-slider-with-title": ItemsSliderWithTitle,
        "element-generator": ElementGenerator,
        "order-type-selector": OrderTypeSelector
    },

    metaInfo: function() {
        const partnerSettings = (this as any).partnerSettings || {};
        const selectedStoreDetails = (this as any).selectedStoreDetails || {};
        const vueAppConfig = getRuntimeSeoConfig();

        const partnerName = partnerSettings.partnerName || vueAppConfig.VUE_APP_Title || "Online Store";
        const storeName = selectedStoreDetails.displayName || partnerName;
        const title = buildSeoTitle({
            primary: storeName,
            siteName: partnerName,
            descriptor: "Online Shopping",
            city: selectedStoreDetails.address && selectedStoreDetails.address.city
        });
        const description =
            selectedStoreDetails.description ||
            `Shop groceries, fresh products, offers, and daily essentials online from ${storeName}.`;
        const keywords = partnerSettings.seoKeywords || vueAppConfig.VUE_APP_Meta_Keywords || "";
        const image =
            selectedStoreDetails.storeLogoUrl ||
            selectedStoreDetails.storeStandardLogoUrl ||
            partnerSettings.seoImageUrl ||
            partnerSettings.appBarLogoUrl ||
            partnerSettings.logoUrl ||
            "";
        const canonicalUrl = buildCanonicalUrl(this);

        return buildSeoMeta({
            title,
            description,
            keywords,
            image,
            canonicalUrl,
            structuredData: buildStoreJsonLd({
                name: storeName,
                url: canonicalUrl,
                image,
                telephone: selectedStoreDetails.phoneNumbers && selectedStoreDetails.phoneNumbers.length > 0
                    ? selectedStoreDetails.phoneNumbers[0]
                    : partnerSettings.customerServicePhoneNumber,
                address: selectedStoreDetails.address
                    ? {
                        streetAddress: selectedStoreDetails.address.streetNbre,
                        addressLocality: selectedStoreDetails.address.city || selectedStoreDetails.address.area,
                        addressRegion: selectedStoreDetails.address.state,
                        addressCountry: selectedStoreDetails.address.country
                    }
                    : undefined
            })
        });
    },

    computed: {        
        ...mapState("partner", ["appDataContent", "partnerSettings"]),
        ...mapState("store", ["selectedStoreDetails"]),
        ...mapState("product", ["storeHomePage", "categoriesAndSubCatList", "departmentsList"]),
        ...mapState("loading", ["storeHomePageLoading"]),
        ...mapState("ui", ["isMobileViewDisplayed"]),

        listOfSectionsTitle(): string[] {
            // 1- Featured Items
            // 2- Promo Items
            // 3- recently added products
            // 4- shop by brand
            // 5- bundles
            return [    
                this.appDataContent.productTypeDescriptionByFeatureProducts, 
                this.appDataContent.productTypeDescriptionByPromo,
                this.appDataContent.productTypeDescriptionByNewlyAdded, 
                this.appDataContent.bundles, 
            ]
        },

        isStoreTypeConvinient(): boolean {
            return (this.selectedStoreDetails as StoreSettings).storeType == EStoreType.Convenient;
        }, 


        isDepartmentsHighestLayer(): boolean { 

            return ((this as any).selectedStoreDetails as StoreSettings).categorizationAndStructureLayer.group == ECategorizationLayerGroup.GroupThree || ((this as any).selectedStoreDetails as StoreSettings).categorizationAndStructureLayer.group == ECategorizationLayerGroup.GroupFour   
                  
        },

        storeHomeHeading(): string {
            const selectedStoreDetails = this.selectedStoreDetails as StoreSettings;

            return selectedStoreDetails && selectedStoreDetails.displayName
                ? selectedStoreDetails.displayName
                : (this.partnerSettings as any).partnerName || "Store";
        }
    },

    methods: {
        onViewAllClick(index: number) {
            routerManager.goToItemsBySectionPage(this.listOfSectionsTitle[index], index);
        },

        onCustomCollectionViewAllClick(campaign: any) {
            this.$router.push({
                name: "productsPageByCampaign",
                params: {
                    campaignId: campaign.id,
                    campaignName: campaign.campaignInfo.name,
                    campaignCollectionType: campaign.itemsCollectionType,
                    title: campaign.campaignInfo.name,
                },
                
                query: {
                    type: campaign.itemsCollectionType,
                    typeId: campaign.itemsCollectionId,
                }

            });
        },

        async getStoreHomePageCall() {   
            await StoreService.getStoreHomePageData();
        },
    },

    watch: {
        async storeId() {
            await this.getStoreHomePageCall()
        },

        async isMobileViewDisplayed() {
            await this.getStoreHomePageCall();
        },

        storeHomePageLoading(val: boolean) {
            this.$emit("loadingState", val)
        } 
    },

    async mounted() {
        // OrderTypeService.SetDefaultOrderType();
        await this.getStoreHomePageCall();
    }
})
